import {ChangeDetectorRef, Component, OnInit, ViewChild} from '@angular/core';
import {AbstractVisbosComponent} from '../../../../core/visbos-core/components/abstract-visbos.component';
import {SessionActions} from '../../../../shared/actions';
import {AssetsListComponent} from '../../components/assets-list/assets-list.component';
import {ApolloQueryObservable} from 'apollo-angular';
import {FetchAssetsQuery} from '../../../../shared/graphql/graphql.types';
import {AssetService} from '../../services/asset.service';
import {FileService} from '../../../../core/visbos-core/http/file.service';
import {GenericModalComponent} from '../../../../core/visbos-core/ui/forms/generic-modal/generic-modal.component';
import {EditAssetComponent} from '../../components/edit-asset/edit-asset.component';
import {Asset} from '../../../../shared/view-model/store-management/asset.type';
import {MessageType} from '../../../../shared/redux-store/session';

@Component({
  selector: 'vb-asset-list-view',
  templateUrl: './asset-list-view.component.html',
  styleUrls: ['./asset-list-view.component.css']
})
export class AssetListViewComponent extends AbstractVisbosComponent implements OnInit {

  /**
   * TODO: Migrate Apollo
   */
  private assets$: ApolloQueryObservable<FetchAssetsQuery>;
  public assets;
  assetsLoading = false;
  exportLoading = false;

  assetToEdit: Asset;

  @ViewChild('assetsList')
  assetsList: AssetsListComponent;

  @ViewChild('editAssetModal')
  editAssetModal: GenericModalComponent;

  @ViewChild('assetForm')
  assetForm: EditAssetComponent;

  constructor(sessionActions: SessionActions, cd: ChangeDetectorRef, private assetService: AssetService, private fileService: FileService) {
    super(sessionActions, cd);

    this.actions = [
      {
        label: 'Liste exportieren',
        icon: 'fa-file',
        action: () => this.onDownloadAssetList.apply(this),
        helpText: 'Exportiert die Gegenstände-Liste in eine Excel-Datei'
      }
    ];

  }

  ngOnInit(): void {
    super.ngOnInit();
    this.assets$ = this.assetService.fetchAssets();
    this.addComponentData(this.assets$);
    this.assetsLoading = true;
    this.addSubscription(this.assets$.subscribe(res => {
      this.assetsLoading = res.loading;
      this.assets = res.data.assetList;
    }, err => {
      this.sessionActions.throwError(err, "Fehler beim Abrufen von Gegenständen!", "Gegenstände");
      this.assetsLoading = false;
    }));
  }

  onDownloadAssetList() {
    this.exportLoading = true;
    this.assetService.exportAssetList()
      .subscribe(response => {
        this.exportLoading = false;
        this.fileService.saveToFileSystem(response);
      }, err => {
        this.exportLoading = false;
      });
  }

  editAssetClicked(asset) {
    this.assetToEdit = asset;
    this.editAssetModal.show();
    this.cd.detectChanges();
  }

  saveAsset(assetData) {
    this.assetService.updateAsset(assetData.cuid, assetData).subscribe(
      res => {
        this.sessionActions.pushMessage("Gegenstand erfolgreich gespeichert", MessageType.SUCCESS);
      },
      err => {
        this.sessionActions.throwError(err, "Fehler beim Speichern des Gegenstands!");
      }
    );
    this.assetToEdit = null;
    this.cd.detectChanges();
  }

}



// WEBPACK FOOTER //
// ./src/app/store-management/asset-management/views/asset-list-view/asset-list-view.component.ts